import Button from "@components/atoms/Button";
import { type BasicOptionType } from "@components/atoms/CheckBox";
import Input from "@components/atoms/Input";
import { StyledRadio } from "@components/atoms/Radio";
import { ConnectionCategory, InputContentsWrap, InputWrap, Label, LabelInnerWrap, LabelWrap } from "@pages/BannerCreate";
import { type BannerCreateInitValuesType } from "@pages/BannerCreate/Data";
import { colors } from "@styles/index";
import { Radio, type RadioChangeEvent } from "antd";
import { type FormikContextType } from "formik";
import React from "react";
import styled from "styled-components";
import useGlobalModal from "@hooks/useGlobalModal";
import { V2BannerCreateRequestDtoLinkType as LinkType } from "@everon-it/api-client/contents-gw";
import { ConnectionSelectedItem } from "../ConnectionSelectItem";
import PublishPeriodNotification from "../PublishPeriodNotification";

type RenderBannerConnectionListProps = {
    formik: FormikContextType<BannerCreateInitValuesType>;
    connectionKindList: BasicOptionType<LinkType>;
    setConnectionKindList: React.Dispatch<React.SetStateAction<BasicOptionType<LinkType>>>;
};

const RenderBannerConnectionList: React.FC<RenderBannerConnectionListProps> = ({ formik, connectionKindList, setConnectionKindList }) => {
    const { showConnectionModal } = useGlobalModal();

    return (
        <InputWrap>
            <LabelWrap>
                <LabelInnerWrap>
                    <Label>연결 목록 선택</Label>
                </LabelInnerWrap>
            </LabelWrap>
            <InputContentsWrap>
                <div style={{ paddingTop: 12, width: "100%" }}>
                    <Radio.Group
                        onChange={(value: RadioChangeEvent) => {
                            const category = value.target.value;

                            const selectedCategory = ConnectionCategory.find(({ value }) => value === category);
                            if (selectedCategory) {
                                setConnectionKindList(selectedCategory);
                            }

                            formik.setFieldValue("linkTargetId", "");
                            formik.setFieldValue("linkTargetTitle", "");
                            formik.setFieldValue("linkUrl", "");
                            formik.setFieldValue("linkType", category);
                        }}
                        defaultValue={ConnectionCategory[0].value}
                        value={connectionKindList.value}
                    >
                        {ConnectionCategory.map(({ label, value }) => {
                            return (
                                <StyledRadio key={label} value={value}>
                                    {label}
                                </StyledRadio>
                            );
                        })}
                    </Radio.Group>

                    <ConnectButtonWrap>
                        {connectionKindList.value === LinkType.URL ? (
                            <StyledDiv
                                style={{
                                    padding: "unset",
                                }}
                            >
                                <Input inputType="create" id="linkUrl" name="linkUrl" onChange={formik.handleChange} value={formik.values.linkUrl} full placeholder={"연결할 URL을 입력해주세요."} />
                            </StyledDiv>
                        ) : (
                            <>
                                {formik.values.linkTargetId && formik.values.linkTargetTitle ? (
                                    <ConnectionSelectItemWrap>
                                        <ConnectionSelectedItem
                                            title={formik.values.linkTargetTitle ?? ""}
                                            onClick={() => {
                                                formik.setFieldValue("linkTargetId", "");
                                                formik.setFieldValue("linkTargetTitle", "");
                                            }}
                                        />
                                        {formik.values.linkTargetDisplayStartAt && formik.values.linkTargetDisplayEndAt && (
                                            <PublishPeriodNotification contentStartAt={formik.values.linkTargetDisplayStartAt} contentEndAt={formik.values.linkTargetDisplayEndAt} />
                                        )}
                                    </ConnectionSelectItemWrap>
                                ) : (
                                    <Button
                                        buttonType="line_primary"
                                        buttonSize="regular"
                                        text={`${connectionKindList.label} 불러오기`}
                                        onClick={() => {
                                            showConnectionModal({
                                                category: connectionKindList.value,
                                                modalHeaderTitle: `${connectionKindList.label} 연결`,
                                                contentTitle: `${connectionKindList.label} 목록`,
                                                firstButtonText: "취소",
                                                secondButtonText: "확인",
                                                formik,
                                            });
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </ConnectButtonWrap>
                </div>
            </InputContentsWrap>
        </InputWrap>
    );
};

export default RenderBannerConnectionList;

const StyledDiv = styled.div`
    padding-left: 200px;
`;

const ConnectButtonWrap = styled.div`
    position: relative;
    padding-top: 24px;
    margin-top: 20px;

    ::before {
        content: "";
        width: 100%;
        height: 1px;
        background: ${colors.GRAY10};
        position: absolute;
        top: 0px;
    }
`;

const ConnectionSelectItemWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;
